import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5752d6d9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "eval-star" }
const _hoisted_2 = {
  key: 0,
  class: "eval-star__toolbar"
}
const _hoisted_3 = { class: "eval-star__scroll" }
const _hoisted_4 = { class: "eval-star__table" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "col-star" }, "星级", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "col-range" }, "分数区间", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "col-desc" }, "描述", -1))
const _hoisted_8 = {
  key: 0,
  class: "col-op"
}
const _hoisted_9 = { class: "col-star" }
const _hoisted_10 = {
  key: 0,
  class: "readonly-text"
}
const _hoisted_11 = {
  key: 1,
  class: "star-level-input"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "star-level-suffix" }, "星", -1))
const _hoisted_13 = { class: "col-range" }
const _hoisted_14 = {
  key: 0,
  class: "readonly-text"
}
const _hoisted_15 = {
  key: 1,
  class: "star-range-inputs"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "star-range-sep" }, "[", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "star-range-sep" }, ",", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "star-range-sep" }, ")", -1))
const _hoisted_19 = { class: "col-desc" }
const _hoisted_20 = {
  key: 0,
  class: "readonly-text"
}
const _hoisted_21 = {
  key: 0,
  class: "col-op"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_input = _resolveComponent("a-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isReadonly)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_a_button, {
            size: "small",
            onClick: _ctx.addRow
          }, {
            default: _withCtx(() => [
              _createTextVNode("+ 新增")
            ]),
            _: 1
          }, 8, ["onClick"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("table", _hoisted_4, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _hoisted_5,
            _hoisted_6,
            _hoisted_7,
            (!_ctx.isReadonly)
              ? (_openBlock(), _createElementBlock("th", _hoisted_8, "操作"))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.starRules, (rule, index) => {
            return (_openBlock(), _createElementBlock("tr", { key: index }, [
              _createElementVNode("td", _hoisted_9, [
                (_ctx.isReadonly)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.starLevelText(rule.starLevel)), 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createVNode(_component_a_input_number, {
                        value: rule.starLevel,
                        "onUpdate:value": ($event: any) => ((rule.starLevel) = $event),
                        class: "star-level-number",
                        controls: false,
                        min: 1,
                        precision: 0,
                        placeholder: "星级",
                        onChange: _ctx.emitChange
                      }, null, 8, ["value", "onUpdate:value", "onChange"]),
                      _hoisted_12
                    ]))
              ]),
              _createElementVNode("td", _hoisted_13, [
                (_ctx.isReadonly)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.formatStarRange(rule) || '-'), 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _hoisted_16,
                      _createVNode(_component_a_input_number, {
                        value: rule.minScore,
                        "onUpdate:value": ($event: any) => ((rule.minScore) = $event),
                        class: "star-range-input",
                        controls: false,
                        placeholder: "下限",
                        onChange: _ctx.emitChange
                      }, null, 8, ["value", "onUpdate:value", "onChange"]),
                      _hoisted_17,
                      _createVNode(_component_a_input_number, {
                        value: rule.maxScore,
                        "onUpdate:value": ($event: any) => ((rule.maxScore) = $event),
                        class: "star-range-input",
                        controls: false,
                        placeholder: "上限",
                        onChange: _ctx.emitChange
                      }, null, 8, ["value", "onUpdate:value", "onChange"]),
                      _hoisted_18
                    ]))
              ]),
              _createElementVNode("td", _hoisted_19, [
                (_ctx.isReadonly)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(rule.description || '-'), 1))
                  : (_openBlock(), _createBlock(_component_a_input, {
                      key: 1,
                      value: rule.description,
                      "onUpdate:value": ($event: any) => ((rule.description) = $event),
                      class: "star-desc-input",
                      maxlength: 32,
                      placeholder: "请输入描述",
                      onChange: _ctx.emitChange
                    }, null, 8, ["value", "onUpdate:value", "onChange"]))
              ]),
              (!_ctx.isReadonly)
                ? (_openBlock(), _createElementBlock("td", _hoisted_21, [
                    _createVNode(_component_a_button, {
                      type: "link",
                      size: "small",
                      danger: "",
                      disabled: !_ctx.canDelete,
                      onClick: ($event: any) => (_ctx.removeRow(index))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" - 删除 ")
                      ]),
                      _: 2
                    }, 1032, ["disabled", "onClick"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}